import { useOnlineStatus } from '../../lib/pwa';
import { FiWifiOff, FiWifi } from 'react-icons/fi';

export default function NetworkStatus() {
  const isOnline = useOnlineStatus();

  // Only show when offline
  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-red-900 text-white px-4 py-2 z-50">
      <div className="flex items-center justify-center">
        <FiWifiOff className="h-4 w-4 mr-2" />
        <span className="text-sm font-medium">
          You're offline. Some features may be limited.
        </span>
      </div>
    </div>
  );
}
